import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "../../data/services";

export const TechMarquee = () => {
  return (
    <section
      data-testid="marquee-section"
      className="relative z-10 py-14 md:py-20 bg-[#f4f3ee] border-y border-black/10 overflow-hidden"
    >
      <Marquee speed={55} gradient={false} className="overflow-hidden">
        {MARQUEE_ITEMS.map((item, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-head text-4xl sm:text-6xl md:text-7xl font-extrabold tracking-tight px-8 ${
                i % 2 === 0 ? "text-[#111111]" : "text-stroke"
              }`}
            >
              {item}
            </span>
            <span className="text-[#2f4bff] text-3xl md:text-5xl px-2">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default TechMarquee;
